export const UNCONFIRMED_NOTIFICATIONS_THRESHOLD = 7;
